module.exports = __webpack_public_path__ + "static/img/PC-8.f9853e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcga/PC-8.png
// module id = xUP8
// module chunks = 0